if (!customElements.get('swiper-slider-slideshow')) {
  class SwiperSliderSlideshow extends HTMLElement {
    connectedCallback() {
      this.classList.add('swiper');

      const showPagination = this.dataset.showPagination === 'true';
      const showArrows = this.dataset.showArrows === 'true';
      const autoRotate = this.dataset.autoplay === 'true';
      const speed = parseInt(this.dataset.speed) || 5000;
      const swiperOptions = {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: autoRotate
          ? {
              delay: speed,
              disableOnInteraction: false,
            }
          : false,
      };
      if (showPagination) {
        swiperOptions.pagination = {
          el: this.querySelector('.swiper-pagination'),
          type: 'fraction',
        };
      }

      if (showArrows) {
        swiperOptions.navigation = {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        };
      }

      new Swiper(this, swiperOptions);
    }
  }

  customElements.define('swiper-slider-slideshow', SwiperSliderSlideshow);
}
